<template>
  <div class="MarketCreate">
    <div class="create">
      <div class="top">
        <div style="display: flex;align-items: center">
          <el-button class="return" v-if="bid!=='0'" size="medium" round icon="el-icon-arrow-left" @click="onReturn">
            Return
          </el-button>
          <p class="title">{{bid!=='0'?'Brand Detail':'Create Brand'}}</p>
        </div>

        <div class="action">
          <el-button round class="button" size="small" :disabled="!error_check" :type="error_check?'primary':'info'"
                     @click="onSave">Save
          </el-button>
        </div>
      </div>
      <div class="body">
        <!-- Product ID -->
        <div class="item" v-if="bid!=='0'">
          <p class="item_name">Brand ID：{{ bid }}</p>
        </div>
        <!-- Product Name -->
        <div class="item">
          <p class="item_name"><span style="color: #F56C6C">*</span> Brand Name</p>
          <div class="item_input">
            <p>EN</p>
            <el-input size="medium" style="width: 300px" v-model="detail.name_en" placeholder="Enter English Name"
                      maxlength="30" show-word-limit autocomplete="off"></el-input>
          </div>
          <div class="item_input">
            <p>CN</p>
            <el-input size="medium" style="width: 300px" v-model="detail.name_cn" placeholder="Enter Chinese Name"
                      maxlength="30" show-word-limit autocomplete="off"></el-input>
          </div>
        </div>

        <!-- Product Info -->
        <div class="item">
          <p class="item_name"><span style="color: #F56C6C">*</span> Brand Info</p>
          <div class="item_input">
            <p>EN</p>
            <el-input
                type="textarea"
                style="width: 500px"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="Enter English Info"
                v-model="detail.info_en">
            </el-input>
          </div>
          <div class="item_input">
            <p>CN</p>
            <el-input
                type="textarea"
                style="width: 500px"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="Enter Chinese Info"
                v-model="detail.info_cn">
            </el-input>
          </div>
        </div>

        <!-- clockin_reward -->
        <div class="item">
          <p class="item_name" style="display: inline-block;margin-right: 10px;">Clockin Reward (default 0)</p>
          <el-input-number size="small" style="width: 110px" v-model="detail.clockin_reward" :controls="false" label=""></el-input-number>
        </div>

        <!-- sort -->
        <div class="item">
          <p class="item_name" style="display: inline-block;margin-right: 10px;">Brand Sort (desc, default 0)</p>
          <el-input-number size="small" style="width: 110px" v-model="detail.sort" :controls="false" label=""></el-input-number>
        </div>

        <!-- Enable Disclaimer -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left" >Show Disclaimer</p>
          <el-switch style="float: right" v-model="detail.show_disclaimer" active-color="#409EFF" inactive-color="#a1a1a1"></el-switch>
        </div> -->

        <!-- Setting Virtual Product -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left" >Virtual Product</p>
          <el-switch style="float: right" v-model="detail.virtual_product" active-color="#409EFF" inactive-color="#a1a1a1"></el-switch>
        </div> -->

        <!-- Default Price -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left" ><span style="color: #F56C6C">*</span> Default Price</p>
          <el-input size="small" style="width: 130px;float: right" v-model="detail.base_price" autocomplete="off">
            <template slot="append">￥</template>
          </el-input>
        </div> -->

        <!-- Special Discount -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left"><span style="color: #F56C6C">*</span> Special Discount</p>
          <el-input size="small" style="width: 130px;float: right" v-model="detail.discount_rate" autocomplete="off">
            <template slot="append">%</template>
          </el-input>
        </div> -->

        <!-- Setting Zocoin Discount -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left" >Zocoin Discount</p> -->
          <!-- <el-switch style="float: right" v-model="detail.zocoin_discount" active-color="#409EFF" inactive-color="#a1a1a1"></el-switch> -->
          <!-- <el-input size="small" style="width: 130px;float: right" v-model="detail.zocoin_discount" autocomplete="off">
            <template slot="append">%</template>
          </el-input>
        </div> -->

        <!-- Setting Only Use Zocoin -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left;margin-right: 10px;" >Only Use Zocoin</p><div style="color: #a1a1a1;font-size: 0.8rem;width: 200px;display: inline;">When Turn on, Zocoin Discount will force 100%</div>
          <el-switch style="float: right" v-model="detail.only_zocoin" active-color="#409EFF" inactive-color="#a1a1a1"></el-switch>
        </div> -->

        <!-- Product Category -->
        <!-- <div class="item_line">
          <p class="item_name" style="float: left"><span style="color: #F56C6C">*</span> Category</p>
          <el-select size="small" v-model="detail.category_id" style="width: 160px;float: right" filterable
                     placeholder="Select category">
            <el-option
                v-for="item in category_list"
                :key="item.pro_category_id"
                :label="item.pro_category_name_en"
                :value="item.pro_category_id">
            </el-option>
          </el-select>
        </div> -->

        <!-- Product Option -->
        <!-- <div class="item_line" v-if="bid==='0'">
          <p class="item_name" style="float: left"><span style="color: #F56C6C">*</span> Options</p>
          <el-select @change="onOptionChange" size="small" v-model="template_id" style="width: 160px;float: right"
                     placeholder="Option Template">
            <el-option
                v-for="item in template_list"
                :key="item.template_id"
                :label="item.template_name"
                :value="item.template_id">
            </el-option>
          </el-select>
        </div> -->

        <!-- Product option checkbox-->
        <!-- <template v-if="bid==='0'">
          <div class="checkbox"
               v-for="(item,index) in option_detail.option_items"
               :key="index">
            <div class="box">
              <p class="box_title">{{item.name}}</p>
              <div class="box_group">
                <el-checkbox-group @change="onBoxChange" style="margin-right: 20px"
                                   v-model="check_list[template_index].option_items[index]"
                                   v-for="(d,i) in item.details"
                                   :key="i">
                  <el-checkbox :label="d.name"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </template> -->


        <!-- Product Option Table (create)-->
        <!-- <p class="item_name" v-if="bid!=='0'"><span style="color: #F56C6C">*</span> Options</p>
        <div class="table" v-if="table_show&&bid==='0'">
          <table>
            <thead class="table_head">
            <tr>
              <th class="head_item"
                  v-show="check_list[template_index].option_items[index].length!==0"
                  v-for="(item,index) in option_detail.option_items"
                  :key="index">
                {{item.name}}
              </th>

              <th class="head_item">Stock</th>
              <th class="head_item">
                <el-tooltip class="item" effect="dark" content="Set 0 to use Default Price" placement="top">
                  <p>*Price ￥</p>
                </el-tooltip>
              </th>
            </tr>
            </thead>
            <tbody v-if="detail.table_list[template_index].length!==0" class="table_body">
            <tr v-for="(item,index) in detail.table_list[template_index]" :key="index">
              <td v-for="i in item.options" class="body_item" :key="i">{{i}}</td>
              <td>
                <div class="stock">
                  <el-input-number size="small" style="width: 110px" v-model="item.stock" :min="0"
                                   label=""></el-input-number>
                </div>
              </td>
              <td>
                <div class="stock">
                  <el-input-number size="small" style="width: 120px" v-model="item.price" :min="0"
                                   label=""></el-input-number>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div> -->

        <!-- Product Option Table (edit)-->
        <!-- <div class="table" v-if="bid!=='0'">
          <table>
            <thead class="table_head">
            <tr>
              <th class="head_item" v-for="(item,index) in detail.product_option_items" :key="index">
                {{item.name}}
              </th>
              <th class="head_item">Stock</th>
              <th class="head_item">
                <el-tooltip class="item" effect="dark" content="Set 0 to use Default Price" placement="top">
                  <p>*Price ￥</p>
                </el-tooltip>
              </th>
            </tr>
            </thead>
            <tbody class="table_body">
            <tr v-for="(item,index) in detail.product_option_records" :key="index">
              <td v-for="i in item.options" class="body_item" :key="i">{{i}}</td>
              <td>
                <div class="stock">
                  <el-input-number size="small" style="width: 110px" v-model="item.stock" :min="0"
                                   label=""></el-input-number>
                </div>
              </td>
              <td>
                <div class="stock">
                  <el-input-number size="small" style="width: 120px" v-model="item.price" :min="0"
                                   label=""></el-input-number>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div> -->

        <div class="upload_abs">
          <!-- Logo Upload -->
          <div class="upload">
            <p><span style="color: #F56C6C">*</span> Upload Logo Images (Up to 1)</p>
            <ImageUpload :limit="1" target="logo" :input="bid!=='0'?detail.logo_images:[]"
                         @output="onUpdateImage"></ImageUpload>
          </div>
          <!-- Banner Upload -->
          <div class="upload">
            <p>Upload Banner Images (Up to 6)</p>
            <ImageUpload :limit="6" target="banner" :input="bid!=='0'?detail.banner_images:[]"
                         @output="onUpdateImage"></ImageUpload>
          </div>

          <!-- Detail Upload -->
          <div class="upload">
            <p>Upload Detail Images (Up to 3)</p>
            <ImageUpload :limit="3" target="detail" :input="bid!=='0'?detail.detail_images:[]"
                         @output="onUpdateImage"></ImageUpload>
          </div>

          <!-- Detail Video Upload -->
          <div class="upload">
            <p>Upload Product Video (Up to 1) (Optional)</p>
            <VideoUpload style="margin-bottom: 20px" :input="bid!=='0'?detail.product_video_url:''"
                         @remove="onRemoveVideo" @output="onUpdateVideo"></VideoUpload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    detailProductOption,
    getBrandDetail,
    savebrandDetail
  } from "@/utils/api";
  import {arraysLoop} from "@/utils/util";
  import ImageUpload from "@/components/Images/Images";
  import VideoUpload from "@/components/Videos/Videos";

  export default {
    props: ['mode', 'bid'],
    components: {
      ImageUpload,
      VideoUpload,
    },
    data: () => {
      return {
        detail: {
          id: '',
          name_en: '',
          name_cn: '',
          info_en: '',
          info_cn: '',
          clockin_reward: 0,
          sort: 0,
          // show_disclaimer:false,
          // virtual_product:false,
          // only_zocoin:false,
          // zocoin_discount:0,
          // base_price: '',
          // discount_rate: 0,
          // category_id: '0',
          logo_images: [],
          banner_images: [],
          detail_images: [],
          // table_list: [],
          video_path: '',
          video_ratio: 16 / 9,
        },
        // category_list: [],
        // template_list: [],
        // template_id: '',
        // option_detail: false,
        // check_list: [],
        // template_index: 0,
        // table_show: false,
        error_check: false,
        // review_list: []
      }
    },
    watch: {
      detail: {
        handler(n) {
          let error = 0;
          let check = [
            n.name_en !== '',
            n.name_cn !== '',
            n.info_en !== '',
            n.info_cn !== '',
            !isNaN(n.clockin_reward),
            !isNaN(n.sort),
            // n.discount_rate !== '' && n.discount_rate >= 0 && !isNaN(n.discount_rate),
            // n.zocoin_discount !== '' && n.zocoin_discount >= 0 && !isNaN(n.zocoin_discount),
            n.logo_images.length !== 0,
            // n.banner_images.length !== 0,
            // n.detail_images.length !== 0,
            // n.video_path !== '',
            // this.table_show === true
          ];
          check.forEach(v => {
            if (!v) {
              error += 1
            }
          });
          this.error_check = error === 0;
        },
        deep: true
      }
    },
    methods: {
      onReturn() {
        this.$emit('return')
      },
      onSave() {
        this.$showLoading();
        let detail = {...this.detail};
        savebrandDetail(detail).then(res => {
          this.$hideLoading();
          if (res.errcode === 0) {
            this.$message.success('Brand Saved');
            this.$emit('back')
          } else {
            this.$message.error('Error in saving Brand')
          }
        })
      },

      onUpdateImage(e) {
        if (e.target === 'banner') {
          this.detail.banner_images = e.image_list
        } else if (e.target === 'detail') {
          this.detail.detail_images = e.image_list
        }else if (e.target === 'logo') {
          this.detail.logo_images = e.image_list
        }
      },
      onUpdateVideo(e) {
        this.detail.video_path = e.video_path;
        this.detail.video_ratio = e.video_ratio
      },
      onRemoveVideo() {
        this.detail.video_path = '';
        this.detail.video_ratio = 16 / 9
      },
      onTableShow() {
        let option_item = [...this.check_list[this.template_index].option_items];
        let count = 0;
        option_item.forEach(v => {
          if (v.length !== 0) {
            count += 1
          }
        });
        this.table_show = count !== 0;
      },
      onBoxChange() {
        this.onTableShow();
        let option_item = [...this.check_list[this.template_index].option_items];
        this.detail.table_list.splice(this.template_index, 1, arraysLoop(option_item));
      },
      onOptionChange(id) {
        detailProductOption(id).then(res => {
          if (res.errcode === 0) {
            this.option_detail = res.option_detail;
            let index;
            this.check_list.forEach((v, i) => {
              if (v.template_id === id) {
                index = i;
                this.template_index = index;
              }
            });
            this.onTableShow();
            if (this.check_list[index].option_items.length !== res.option_detail.option_items.length) {
              res.option_detail.option_items.forEach(() => {
                this.check_list[index].option_items.push([])
              });
            }
          } else {
            this.$message.error('Error in getting option detail')
          }
        })
      },
      onScrollReview(event) {
        let scroll_total = event.target.scrollHeight;
        let scroll_current = event.target.scrollTop + event.target.offsetHeight;
        let interval = 2000;
        if (scroll_total - scroll_current <= 20 && !this.scroll_block) {
          this.scroll_block = true;
          setTimeout(() => {
            this.scroll_block = false;
          }, interval)
        }
      },
    },
    beforeMount() {
      if (this.bid !== '0') {
        getBrandDetail(this.bid).then(res => {
          let d = res.detail;
          d.id = this.bid;
          d.name_en = d.brand_name_en;
          d.name_cn = d.brand_name_cn;
          d.info_en = d.brand_info_en;
          d.info_cn = d.brand_info_cn;
          d.video_path = d.brand_video_url;
          d.video_ratio = d.brand_video_ratio;
          this.detail = d;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_BrandCreate.scss";
</style>